<!-- Required, not decoration. showOkMessage goes through ConfirmationService keyed to this
     dialog's own DialogWrapperService; with no p-confirmDialog carrying that key the confirm
     never renders, the promise never settles, and Ok reads as a dead button. -->
<p-confirmDialog [closable]="false" [key]="dialogKey" [baseZIndex]="1000"></p-confirmDialog>
<div *ngIf="isPageReady" class="flex flex-col h-full">
  <div class="qb-content-card">
    <div class="qb-detail-card w-full h-fit">
      <div class="flex flex-col gap-3">
        <div class="flex flex-row gap-3">
          <!-- Shown, never typed. The id is part of a pair with the enum in the code, so the
               operator needs to read it to tell a developer which row to add. Sized to the two
               digits it holds rather than to a share of the form. -->
          <qb-field label="Id" class="w-16 shrink-0">
            <input [ngModel]="featureKind.id" name="id" disabled pInputText title="Id" />
          </qb-field>
          <qb-field label="Name" class="flex-1">
            <input #firstInput [(ngModel)]="featureKind.name" [bzModel]="featureKind" name="name" pInputText title="Name" />
          </qb-field>
        </div>
        <span *ngIf="isAdding" class="text-xs italic" style="color: var(--p-text-muted-color, #6b7280)">
          The system gives the feature type this id. A developer needs the id and the name to give
          the type the special handling that Size and Color have.
        </span>
      </div>
    </div>
  </div>

  <div class="flex flex-row gap-2 justify-start mt-4">
    <button [disabled]="!this.uow.hasChanges()" (click)="ok()" pButton type="button" label="Ok" title="Ok" icon="pi pi-check" class="p-button-raised"></button>
    <button (click)="cancel()" pButton type="button" label="Cancel" title="Cancel" icon="pi pi-times" class="p-button-raised"></button>
  </div>
</div>
